import React from 'react';
import HeaderSection from '../../components/reusableComponents/HeaderSection';

const About = () => {
	return (
		<>
			<HeaderSection id={1} />
			<div style={{ padding: 76 }}>
				<div>
					<h1 style={{ textAlign: 'center', fontFamily: 'unset' }}>
						Musafir Bazar Adventure Starts Now
					</h1>
				</div>
				<div>
					<h3 style={{ textAlign: 'center', fontFamily: 'unset' }}>
						"Make the most of yourself by fanning the tiny, inner sparks of
						possibility into flames of achievement"
					</h3>
					<h3 style={{ textAlign: 'center', fontFamily: 'unset' }}>
						"It’s more effective to do something valuable than to hope a logo or
						name will say it for you"
					</h3>
				</div>
				<div style={{ marginTop: 50 }}>
					<h6 style={{ fontFamily: 'unset' }}>
						Started in 2015, Musafir Bazar is a part of the R Arya Aviation
						India PVT LTD. The Company is based in the bustling metropolis of
						Dhanbad, Jharkhand (India). Musafir Bazar have a wide experience of
						working with clients across industries globally. Over these years,
						our main focus is in helping clients in achieving their goals
						through their websites/portals.
					</h6>
					<h6 style={{ fontFamily: 'unset' }}>
						At Musafir Bazar, we go beyond the surface to delve into what you
						actually need, where you lack and guide you right through the
						process of ideation and creation. We help you visualize and finally
						achieve a seamless transition from IDEA to PRODUCT.
					</h6>
					<h6 style={{ fontFamily: 'unset' }}>
						Our main motive is to satisfy your customers with your product and
						simultaneously you achieve growth and success. We develop in such a
						way that your websites attract more and more visitors which can be
						then converted to customers and this will directly lead to high
						revenue. Our client's success is our success and our client's
						satisfaction is our satisfaction.
					</h6>
					<h6 style={{ fontFamily: 'unset' }}>
						We offer a cost-effective way to build/develop and update your
						product, so that you invest with confidence in new product
						development or an update. With us you will not be locked into
						expensive software or web application system because we offer
						maximum flexibility at minimum cost.
					</h6>
				</div>
				{/* <div>
					<h2>About Our Team</h2>
				</div> */}
			</div>
			<section className='footer'>
				<div className='box-container'>
					<div className='box' data-aos='fade-up'>
						<h3>Musafir Bazar</h3>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Company Info
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Company Policy
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Privacy Policy
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Terms & Condition
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Careers
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i>
							About Us
						</a>
					</div>

					<div className='box' data-aos='fade-up'>
						<h3>Products</h3>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Flight Booking
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Bus Booking
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Hotel Booking
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Holiday Booking
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Car Booking
						</a>
					</div>

					<div className='box' data-aos='fade-up'>
						<h3>Contact Info</h3>
						<a href='#'>
							<i className='fas fa-phone'></i> +91 887-777-3388
						</a>
						<a href='#'>
							<i className='fas fa-envelope'></i>sales@musafirbazar.com
						</a>
						<a href='#'>
							<i className='fas fa-map-marker-alt'></i>1st Floor,New Tech Grand,
							Bank More, Dhanbad-826001
						</a>
					</div>

					<div className='box' data-aos='fade-up'>
						<h3>Follow Us</h3>
						<a href='https://www.facebook.com/musafirbazaar' target='_blank'>
							<i className='fab fa-facebook-f'></i> facebook
						</a>
						<a href='https://twitter.com/musafirbazar' target='_blank'>
							<i className='fab fa-twitter'></i> twitter
						</a>
						<a href='https://www.instagram.com/musafirbazar/' target='_blank'>
							<i className='fab fa-instagram'></i> instagram
						</a>
						<a
							href='https://www.linkedin.com/company/musafirbazar'
							target='_blank'>
							<i className='fab fa-linkedin'></i> linkedin
						</a>
						<a href='#'>
							<i className='fab fa-pinterest'></i> pinterest
						</a>
					</div>
				</div>

				<div className='credit' style={{ fontSize: 14 }}>
					Copyright ©2022, All Rights Reserved. Powered by Arya Aviation Pvt.
					Ltd.
				</div>
			</section>
		</>
	);
};

export default About;
